import * as React from 'react';
import * as Redux from 'react-redux';
import { allEstadosAction } from '../EstadosAction';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { ALL_ESTADOS } from '../EstadosReducer';
import { FormHelperText } from '@mui/material';
import { validMessage } from '../../../../constants/ValidsFormConst';

const SelectFieldEstadosComponent = ({
  idPais,
  onChange,
  hasError,
  value,
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const estadosStore = Redux.useSelector((state) => state.estados);

  React.useEffect(() => {
    const fetchData = async () => {
      dispatch({
        type: ALL_ESTADOS,
        payload: { data: [] },
      });
      await allEstadosAction(dispatch, idPais);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idPais]);

  const select = (
    <FormControl fullWidth size="small" required error={hasError}>
      <InputLabel id={`label_${CONST.estado.name}`}>
        {CONST.estado.label}
      </InputLabel>
      <Select
        id={CONST.estado.name}
        value={value}
        labelId={`label_${CONST.estado.name}`}
        label={CONST.estado.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {estadosStore.all.map((el, index) => {
          return (
            <MenuItem key={`estado-${index}`} value={el.id}>
              {el.estado}
            </MenuItem>
          );
        })}
      </Select>
      {hasError && <FormHelperText>{validMessage.required}</FormHelperText>}
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-estados"
      opt={estadosStore.all}
      type={CONST.estado.name}
      onChange={(event, newValue) => onChange(newValue?.id)}
      l="Estados"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldEstadosComponent;
